module.exports = __webpack_public_path__ + "static/accr-dia-5f07a0e1f182e80b5a71334d6331de86.svg";